/* eslint-disable global-require, class-methods-use-this */
// Libs / Helpers
import React, { Component } from 'react';
import QueueList from 'Components/QueueList';
import { getQueueGroupList } from 'Apis/queueManagerApi.js';
import Button from 'Components/Button';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import EmptyState from 'Components/EmptyState/EmptyState';
import { setSearchOpenFlag } from 'Actions/drawerAction';
import DropDownList from 'Components/DropDownList/DropDownList';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { getGeneralQueueMetaData, getGeneralSubQueueMetaData, getPendingCases, getAssignedCasesMetaData } from './configStructure.js';
import './LandingPageNew.scss';
import CaseCountDetail from 'Components/CaseCountDetail/CaseCountDetail';
import { COLORS } from "Constants/BIDashboardConstants.js"

//import GroupSearch from 'Components/GroupSearch';
import { isObject } from 'util';
import {
  getMyQueues,
  getExcepionList,
  getQueueSummary,
  getCategoryLabels,
  getQueueLabels,
  getSubQueueList,
  getNextCasesOfSubQueue,
  saveDefaultRegion
} from 'Apis/queueManagerApi.js';
import { loadState } from '../../store/browserStorage.js';
import ResponseBanner from 'Components/cards/ResponseBanner';
import ImagePortal from 'Containers/ImagePortal';
import PinIcon from '../../../../dims-common-ui/components/icons/PinIcon/PinIcon.jsx';
import UnpinIcon from '../../../../dims-common-ui/components/icons/UnPinIcon/UnPinIcon.jsx';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';

var Labels;
var topLabels = [];
export class LandingPageNew extends Component {

  constructor(props) {
    super(props);
    this.state = {
      queueLabels: [],
      categoryLabels: [],
      regionDataList: [],
      buttonAnalyst: true,
      buttonInternal: false,
      buttonMerchant: false,
      isLoading: true,
      queueSummaryCount: [],
      totalQueueCount: [],
      queueList_1: [],
      queueList_2: [],
      queueListData: [],
      queueDefaultListData: [],
      queueExceptionListData: [],
      selectedInput: [
      ],
      emptyStateHeading: 'Unauthorized',
      emptyStateDescription: 'You are not authorized to view this content.',
      emptyStateNoPermissionsHeading: 'You do not have permission to view the queues',
      emptyStateNoPermissionsDesc: 'Please contact support team for further assistance',
      isCountsFetched: false,
      isSubQueueListFetched: false,
      isDefaultRegionSelected: false
    };
    this.attachBindings();
  }
  componentWillMount() {
    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    this.setState({
      generalQueueMetaData: getGeneralQueueMetaData(),
      generalSubQueueMetaData: getGeneralSubQueueMetaData(),
      pendingCases: getPendingCases(),
      assignedCasesMetaData: getAssignedCasesMetaData(userPermission),
      userPermission,
    });
    this.getQueueGroupList(false);
  }
  componentWillReceiveProps(nextProps) {
    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    if (this.state.userPermission == undefined) {
      this.setState({
        assignedCasesMetaData: getAssignedCasesMetaData(userPermission),
        userPermission
      });
    }
  }

  componentDidMount() {///modify 3 function
    this.getQueueList();
    this.getCategoryLabels();
    this.getQueueLabels();
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  resetDropDownList(nextProps) {
    if (this.props.selectedOption !== nextProps.selectedOption) {
      this.setState({
        selectedOption: nextProps.selectedOption,
      });
    }
  }
  resetScrollPos() {
    this.state.scrollPos = 0;
  }

  attachBindings() {
    this.changeButton = this.changeButton.bind(this);
    this.getQueueList = this.getQueueList.bind(this);
    this.getDefaultQueueList = this.getDefaultQueueList.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.getQueueGroupList = this.getQueueGroupList.bind(this);
    this.getQueueLabels = this.getQueueLabels.bind(this);
    this.getCategoryLabels = this.getCategoryLabels.bind(this);
    this.getQueueSummary = this.getQueueSummary.bind(this);
    this.getSubQueueList = this.getSubQueueList.bind(this);
    this.goToDashBoard = this.goToDashBoard.bind(this);
  }

  goToQueueLanding = (subQueue) => {
    let baseQueuelabel = this.state.subQueueList !== undefined && this.state.subQueueList.filter(obj => obj.queueCategoryCode == null)[0]?.queueLabel;
    const customQueueId = subQueue.customQueueId;
    const regionCode = this.state.selectedInput.value.regionCode;
    const acquirerAccessCode = this.state.selectedInput.value.acquirerAccessCode;
    this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewCasesInQueue &&
      this.props.history.push(`/sub-queue-landing-page?region=${regionCode}&acquirerAccessCode=${acquirerAccessCode}&selectedBaseQueueItem=${baseQueuelabel}&subQueueSelection=${subQueue.queueLabel}&customQueueId=${customQueueId}`);
  };

  goToDashBoard() {
    this.setState({
      noCaseFoundWarnning: false,
    }, () => {
      this.props.history.push({
        pathname: '/dashboard',
      });
    })
  }

  getNextCasesOfSubQueue(subQueue) {
    let userId = JSON.parse(sessionStorage.getItem('state')).auth.user.userId;
    const caseNumber = null;
    return getNextCasesOfSubQueue(subQueue.customQueueId, userId, caseNumber).then((apiResponse) => {
      if (apiResponse.status.statusCode === 2000) {


        let baseQueueSelection = this.state.subQueueList !== undefined && this.state.subQueueList.filter(obj => obj.queueCategoryCode == null)[0]?.queueLabel;
        this.props.history.push(`/caselanding/${apiResponse.data}?selectedBaseQueueItem=${baseQueueSelection}&subQueueSelection=${subQueue.queueLabel}`);

      }
    }).catch((error) => {
      console.log('error received while fetching next case of subqueue', error);
      if (error.response.status === 404) {
        this.setState({
          noCaseFoundWarnning: true,
          isLoading: false
        });
      }
    });
  };

  handleSelectionChange(selectedItem) {
    if (selectedItem) {
      this.setState({ selectedInput: selectedItem, isDefaultRegionSelected: selectedItem.value.isDefaultRegion });
    }
    this.getDefaultQueueList(selectedItem.value);
    let actionCategoryCode;
    if (this.state.buttonAnalyst) {
      actionCategoryCode = "PDAN";
    }
    if (this.state.buttonMerchant) {
      actionCategoryCode = "PDMR";
    }
    if (this.state.buttonInternal) {
      actionCategoryCode = "PDIN";
    }
    this.getQueueSummary(selectedItem.value.regionCode, actionCategoryCode, JSON.parse(sessionStorage.getItem('state')).auth.user.userId);
    this.getSubQueueList(actionCategoryCode, selectedItem.value.regionCode);
  }

  changeButton(e) {
    const queueGroupCode = this.state.selectedInput.value.regionCode;
    let userId = JSON.parse(sessionStorage.getItem('state')).auth.user.userId;
    let actionCategoryCode;
    if (e.target.id == "Analyst") {
      actionCategoryCode = "PDAN";
      this.getQueueSummary(queueGroupCode, actionCategoryCode, userId);
      this.getSubQueueList(actionCategoryCode, queueGroupCode);
      this.setState({ buttonAnalyst: true, buttonMerchant: false, buttonInternal: false });
    }
    if (e.target.id == "Merchant") {
      actionCategoryCode = "PDMR"
      this.getQueueSummary(queueGroupCode, actionCategoryCode, userId);
      this.getSubQueueList(actionCategoryCode, queueGroupCode);
      this.setState({ buttonAnalyst: false, buttonMerchant: true, buttonInternal: false });
    }
    if (e.target.id == "Internal") {
      actionCategoryCode = "PDIN"
      this.getQueueSummary(queueGroupCode, actionCategoryCode, userId);
      this.getSubQueueList(actionCategoryCode, queueGroupCode);
      this.setState({ buttonAnalyst: false, buttonMerchant: false, buttonInternal: true });
    }


  }
  getQueueList() {
    return getMyQueues()
      .then((apiResponse) => {
        const queueListData = apiResponse.data;
        this.setState({
          queueList_1: queueListData,
        });
      })
      .catch((error) => {
        console.log('error received while fetching data columns based on queue page', error);
      });
  }

  getDefaultQueueList(regionListValue) {
    let acquirerAccessList = getAcquirerAccessList();
    return getExcepionList(regionListValue.regionCode, acquirerAccessList)
      .then((apiResponse) => {
        this.setState({
          queueList_2: apiResponse.data,
        });
      })
      .catch((error) => {
        this.setState({
          queueList_2: [],
        });
        console.log('error received while fetching data columns based on queue page', error);
      });
  }

  getQueueSummary(queueGroupCode, actionCategoryCode, userId) {
    let acquirerList = getAcquirerAccessList();
    let pinDebitAcquirerCodes = acquirerList.filter(item => item.endsWith('PD'));
    this.setState({
      isCountsFetched: false,
    }, () => {
      return getQueueSummary(queueGroupCode, actionCategoryCode, userId, null, null, pinDebitAcquirerCodes).then((response) => {
        const queueSummary = response.data;
        this.setState({
          queueSummaryCount: queueSummary,
          totalQueueCount: queueSummary.workableCount,
          isCountsFetched: true,
        });
      }).catch((error) => {
        console.log('error received while fetching data columns based on queue page', error);
      });
    });
  }

  getSubQueueList(actionCategoryCode, queueGroupCode) {
    this.setState({
      isSubQueueListFetched: false,
    }, () => {
      return getSubQueueList(actionCategoryCode, queueGroupCode, true).then((response) => {
        this.setState({
          subQueueList: response.data,
          isSubQueueListFetched: true,
        });
      }).catch((error) => {
        console.log('error received while fetching sub queues', error);
      });
    });
  }

  getQueueGroupList(isDefaultRegionSaved) {
    let actionCategoryCode = "PDAN";
    let userId = JSON.parse(sessionStorage.getItem('state')).auth.user.userId;
    let acquirerAccessList = getAcquirerAccessList();
    if (acquirerAccessList.length !== 0) {
      return getQueueGroupList(acquirerAccessList, userId)
        .then((apiResponse) => {
          const formattedRegionList = apiResponse.data.map((item) => {
            let regionListValue = { regionCode: item.queueGroupCode, acquirerAccessCode: item.acquirerAccessCode, isDefaultRegion: item.defaultRegion };
            return {
              text: item.queueGroupLabel,
              value: regionListValue,
            };
          });

          let defaultRegionIndex = formattedRegionList.findIndex(region => region.value.isDefaultRegion == true)
          if (defaultRegionIndex == -1) {
            defaultRegionIndex = 0
          }
          this.setState({
            regionDataList: formattedRegionList,
            selectedInput: formattedRegionList[defaultRegionIndex],
            isDefaultRegionSelected: formattedRegionList[defaultRegionIndex].value.isDefaultRegion
          }, () => {
            if (!isDefaultRegionSaved) {
              this.getDefaultQueueList(formattedRegionList[defaultRegionIndex].value);
              this.getQueueSummary(this.state.selectedInput.value.regionCode, actionCategoryCode, userId);
              this.getSubQueueList(actionCategoryCode, this.state.selectedInput.value.regionCode);
            }
          });
        })
        .catch((error) => {
          console.log('error received while fetchiformattedRegionListng list of regions', error);
        });
    }
  }

  getQueueLabels() {
    getQueueLabels(false).then(response => {
      this.setState({ queueLabels: response.data });
    })
  }

  getCategoryLabels() {
    getCategoryLabels().then(response => {
      this.setState({ categoryLabels: response.data })
      topLabels = response.data.filter(obj => obj.queueIndicator == "0");
      Labels = response.data.filter(obj => obj.queueIndicator == "1");
    })
  }

  openQueue = (row) => {
    const regionCode = this.getRegionCode(row);
    let queueId = row.queueDescription ? row.queueDescription : row.queueId;
    const acquirerAccessCode = this.state.selectedInput.value.acquirerAccessCode;

    if ([69, 70].includes(queueId)) { // 69-assigned cases and 70 = bookmarked
      this.props.history.push(`/queue-management-landing?region=${regionCode}&queueid=${queueId}&acquirerAccessCode=${acquirerAccessCode}&hideDropdown=true`);
    } else {
      (queueId == 15 || queueId == 81) ? this.props.history.push(`/queue/${queueId}?regionCode=${regionCode}&hideBaseQueueDropdown=true`) : this.props.history.push(`/queue/${queueId}?hideBaseQueueDropdown=true`);
    }
  }

  onSaveDefaultRegionClick = () => {
    if (!this.state.isDefaultRegionSelected) {
      let data = {
        "userId": JSON.parse(sessionStorage.getItem('state')).auth.user.userId,
        "region": this.state.selectedInput.value.regionCode
      }
      return saveDefaultRegion(data).then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          this.setState(state => ({ isDefaultRegionSelected: true }))
          this.getQueueGroupList(true);
          const notificationMessageSuccess = {
            type: 'success',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            contentHtml: `<div style= "color: black;padding-top:10px !important;">
          <b>Success</b>: default region updated successfully.
          </div>`,
          };
          openNotificationToast(notificationMessageSuccess);
        }
      }).catch((error) => {
        const notificationMessageError = {
          type: 'error',
          placement: 'topRight',
          messageWidth: 250,
          byDefault: true,
          duration: 5,
          contentHtml: `<div style= "color: black;padding-top:10px !important;">
        <b>System Error</b>: Unable to update the default region.
        </div>`,
        };
        openNotificationToast(notificationMessageError);
      });
    }
  }

  getDefaultRegionIcon = () => this.state.isDefaultRegionSelected ? <PinIcon />
    : <UnpinIcon />

  getIconSpace = () => {
    let region = this.state.selectedInput.value?.regionCode;
    if (region == "AP") {
      return "200px";
    } else if (["EU", "MX"].includes(region)) {
      return "175px";
    } else if (region == "GLB") {
      return "170px";
    } else if (region == "HPY") {
      return "188px";
    } else if (region == "NA") {
      return "214px";
    } else if (region == "PD") {
      return "188px";
    }
    else {
      return "180px";
    }
  };

  getRegionCode = (selectedRegionData) => {
    if (this.state.selectedInput.value.regionCode == "GLB") {
      return selectedRegionData.queueGroupCode;
    } else if (this.state.selectedInput.value.regionCode == "PD" && selectedRegionData.queueLabel == "NA Un-Matched Merchant Images") {
      return "NA"
    } else if (this.state.selectedInput.value.regionCode == "PD" && selectedRegionData.queueLabel == "HPS Un-Matched Merchant Images") {
      return "HPY"
    } else if (this.state.selectedInput.value.regionCode == "PD" && selectedRegionData.queueLabel == "AP Un-Matched Merchant Images") {
      return "AP"
    }
    return this.state.selectedInput.value.regionCode
  }
  render() {
    window.document.title = 'Disputes Management';
    let pr = 0;
    let de = 0;
    let sp = 0;
    let count = [];
    let totalCount = [];
    let acquirerList = getAcquirerAccessList();
    const workableCountArr = totalCount && totalCount.map((item) => { return item.count });
    const workableCount = workableCountArr && workableCountArr.reduce((a, b) => a + b, 0);
    if (this.props.user !== undefined && this.props.user.parsedPermissions.queue.canViewAll && acquirerList.length !== 0) {
      return (
        <section
          className="case-landing-container-new"
        >
          <div className={this.props.isSearchActive ? 'main-content--header secondary-header' : 'main-content--header'} style={{ zIndex: 1 }}>
            {this.state.noCaseFoundWarnning &&
              <ImagePortal>
                <ResponseBanner
                  titleStyle={{ color: 'light-green' }}
                  descriptionStyle={{ color: 'grey' }}
                  valueStyle={{ color: 'black' }}
                  title="No available case is found."
                  description=""
                  type="warning"
                  onClose={this.goToDashBoard}
                  successOnly={true}
                  primaryButtonText="OKAY"
                  primaryButtonAction={this.goToDashBoard}
                />
              </ImagePortal>
            }
            <div className="flex-left">
              <h1 className="title">Home</h1>
              {this.state.generalQueueMetaData.dataColumns?.map((component, index) => {
                return (
                  isObject(component.dropDownselection) &&
                  this.state.selectedInput.text && (
                    <>
                      <div className="region-dropdown-view">
                        <DropDownList
                          dropDownList={this.state[component.dropDownselection.defSelectKey]}
                          selectedItemText={this.state.selectedInput.text}
                          selectDropdownItem={this.handleSelectionChange}
                          extraStyle={{ left: 5, width: 150 }}
                          wrapperButtonStyle={{
                            left: 0,
                            width: "max-content",
                            backgroundColor: COLORS.oneGp.haze,
                          }}
                          isFocus={false}
                        />
                      </div>
                      <div
                        className={
                          this.state.isDefaultRegionSelected ? "pin-icon" : "unpin-icon"
                        }
                        role="button"
                      >
                        <span onClick={() => this.onSaveDefaultRegionClick()}>
                          {this.getDefaultRegionIcon()}
                        </span>
                      </div>
                    </>
                  )
                );
              }
              )}
            </div>
          </div>
          {
            this.state !== undefined && <div className="main-content--wrapper">

              <div className="homepage">

                {topLabels.map(subQueueLabels => {
                  var subQueueListData = this.state["queueList_" + (subQueueLabels.queueCategoryCode == "MYQ" ? "1" : "2")];
                  return (
                    <div className="myCart">
                      <div className="title-queue">
                        <QueueList
                          id={subQueueLabels.queueCategoryCode}
                          name={subQueueLabels.queueDescription}
                          title={true}
                          cursorView={false}
                        />
                      </div>
                      {
                        subQueueListData === undefined && <BVLoader20 />
                      }
                      {subQueueLabels.queueCategoryCode == "MYQ" && subQueueListData !== undefined && subQueueListData.map((row, index) => {
                        const rowLen = subQueueListData.length;
                        return (<div key={index}>
                          <QueueList
                            id={row.queueId}
                            name={row.queueName}
                            onViewClick={() => this.openQueue(row)}
                          />
                        </div>);
                      })}
                      {subQueueLabels.queueCategoryCode == "EX" && subQueueListData !== undefined && subQueueListData.map((row, index) => {
                        const rowLen = subQueueListData.length;
                        {
                          return (
                            <div key={index}>
                              <QueueList
                                id={row.customQueueId}
                                name={row.queueLabel}
                                onViewClick={() => this.openQueue(row)}
                              />
                            </div>);
                        }
                      })}
                      {
                        subQueueListData !== undefined && subQueueListData.length === 0 &&
                        <div className="message-view">No queues available.</div>
                      }
                    </div>

                  )
                })}

              </div>
              {/* HomePage2 */}
              {(this.state.isCountsFetched && this.state.isSubQueueListFetched) ?
                <div className="SubQueue">
                  <div className="option-buttons">
                    <button id="Analyst" className={this.state.buttonAnalyst ? "button-click" : "button-Unclick"}
                      onClick={(e) => this.changeButton(e)}> {this.state.queueLabels[0]?.categoryDescription} </button>
                    <button id="Merchant" className={this.state.buttonMerchant ? "button-click" : "button-Unclick"}
                      onClick={(e) => this.changeButton(e)}>  {this.state.queueLabels[2]?.categoryDescription} </button>
                    <button id="Internal" className={this.state.buttonInternal ? "button-click" : "button-Unclick"}
                      onClick={(e) => this.changeButton(e)}> {this.state.queueLabels[1]?.categoryDescription} </button>
                  </div>
                  {

                    this.state.pendingCases !== undefined && this.state.pendingCases.dataColumns !== undefined && this.state.pendingCases.dataColumns?.length > 0 &&
                    this.state.pendingCases.dataColumns?.map((cases, index) => {
                      return (
                        <CaseCountDetail
                          dataColumns={cases.columns}
                          caseCountData={this.state.queueSummaryCount}
                          workableCount={this.state.totalQueueCount}
                          user={this.props.user}
                          customQueue={this.state.subQueueList !== undefined && this.state.subQueueList.filter(obj => obj.queueCategoryCode == null)[0]}
                          region={this.state.selectedInput.value?.regionCode}
                        />
                      );
                    })
                  }

                  {/* Sub Queue*/}
                  <div className="homepage-subQueue">
                    {Labels !== undefined &&
                      Labels.map((label, index) => {
                        return (
                          <div className='subQueue-container' key={index}>
                            {
                              <div className="title__subQueue">
                                <QueueList
                                  id={label.queueCategoryCode}
                                  name={label.queueDescription}
                                  title={true}
                                  subQueue={true}
                                  cursorView={false}
                                />
                              </div>}
                            <div className="pending-cart">
                              {


                                <div className='title-list'>

                                  {
                                    Labels === undefined && <BVLoader20 />
                                  }

                                  {this.state.subQueueList !== undefined && this.state.subQueueList.map((row, index) => {
                                    if (row.queueCategoryCode == label.queueDescription) {
                                      if (row.queueCategoryCode == 'Priority') {
                                        pr = pr + 1;
                                      }
                                      if (row.queueCategoryCode == 'Default') {
                                        de = de + 1;
                                      }
                                      if (row.queueCategoryCode == 'Specialty') {
                                        sp = sp + 1;
                                      }
                                      return (<div key={index}>

                                        <QueueList
                                          id={row.queueCategoryCode}
                                          name={row.queueLabel}
                                          subQueue={true}
                                          onViewClick={() => this.goToQueueLanding(row)}
                                          isLanding={true}
                                          user={this.props.user}
                                          customQueueId={row.customQueueId}
                                          goToSubQueueLanding={() => this.getNextCasesOfSubQueue(row)}
                                          cursorView={(this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewCasesInQueue) ? true : false}
                                        />
                                      </div>);
                                    }
                                  })}
                                  {
                                    this.state.subQueueList !== undefined ?
                                      ((label.queueCategoryCode == 'PR' && pr == 0) ||
                                        (label.queueCategoryCode == 'DE' && de == 0) ||
                                        (label.queueCategoryCode == 'SP' && sp == 0))
                                        ? <div className="subQueue-message-view">No custom queues to display.</div> : ''
                                      : <BVLoader20 callingComponent="LandingPageNew" />
                                  }
                                </div>
                              }</div>
                          </div>


                        );
                      })}
                  </div>
                </div>
                : <BVLoader20 />}
            </div>}
        </section>
      );
    } else {
      return (
        <EmptyState
          translations={{
            emptyStateHeading: acquirerList.length === 0 && this.props.user.parsedPermissions.queue.canViewAll ? this.state.emptyStateNoPermissionsHeading : this.state.emptyStateHeading,
            emptyStateDescription: acquirerList.length === 0 && this.props.user.parsedPermissions.queue.canViewAll ? this.state.emptyStateNoPermissionsDesc : this.state.emptyStateDescription
          }}
        />
      );

    }
  }

}

/* eslint-enable global-require, class-methods-use-this */

const mapStateToProps = (state) => ({
  filters: state.searchFilter.filters,
  isSearchActive: state.appSearch.isSearchActive,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFilterElements: (searchTypeId) => {
      dispatch(fetchFilterElements(searchTypeId));
    },
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPageNew));
